<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const emit = defineEmits<{
  /** Emitted when dialog is closed */
  close: []
}>()

defineOptions({
  name: 'AlreadyApprovedErrorDialog'
})

const router = useRouter()
const { t } = useI18n()

const close = (): void => {
  router.back()
  emit('close')
}
</script>

<template>
  <BaseDialog hide-cancel-icon :title="t('entry.already_approved_error.title')">
    <h3>{{ t('entry.already_approved_error.details') }}</h3>
    <template #footer>
      <div class="flex w-full justify-end">
        <BaseButton filled @click="close">
          {{ t('general.return_back_and_close') }}
        </BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>
